/* MontiMeadow: collapse very long SEO text blocks behind a "Read more" button */
(function () {
  function collapseLongText() {
    var sections = document.querySelectorAll('.template-collection .shopify-section[id*="rich_text"], body .shopify-section[id*="rich_text"]');
    sections.forEach(function (section) {
      if (section.dataset.mmCollapsed) return;
      if (!document.querySelector('.collection, #product-grid, .main-collection-product-grid, [id*="main-collection-product-grid"]')) return;
      var blocks = section.querySelectorAll('p, h2, h3, h4, ul, ol');
      if (blocks.length < 6 || section.getBoundingClientRect().height < 900) return;
      // smallest element that contains every text block
      var box = blocks[0].parentElement;
      while (box && box !== section) {
        var all = true;
        for (var i = 0; i < blocks.length; i++) { if (!box.contains(blocks[i])) { all = false; break; } }
        if (all) break;
        box = box.parentElement;
      }
      if (!box || box === section) return;
      var bg = getComputedStyle(box).backgroundColor;
      var p = box;
      while ((bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') && p.parentElement) { p = p.parentElement; bg = getComputedStyle(p).backgroundColor; }
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') box.style.setProperty('--mm-collapse-bg', bg);
      box.classList.add('mm-collapse');
      var wrap = document.createElement('div');
      wrap.className = 'mm-collapse-wrap';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-collapse-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
        if (!open) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      wrap.appendChild(btn);
      box.parentNode.insertBefore(wrap, box.nextSibling);
      section.dataset.mmCollapsed = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseLongText);
  else collapseLongText();
  window.addEventListener('load', collapseLongText);
})();

/* MontiMeadow: cart-drawer free-shipping bar - currency conversion, smooth progress, one-time celebration */
(function () {
  var KEY = 'mmShipPct';
  function getPrev() { try { var v = sessionStorage.getItem(KEY); return v === null ? null : parseFloat(v); } catch (e) { return null; } }
  function setPrev(v) { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} }
  function fmt(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function setup(el) {
    el.dataset.ready = '1';
    var base = parseFloat(el.dataset.base) || 0;
    var total = parseFloat(el.dataset.total) || 0;
    var threshold = base;
    if (el.hasAttribute('data-fx')) {
      var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      if (!rate) { el.style.display = 'none'; return; }
      threshold = Math.round(base * rate);
      var amt = el.querySelector('.mms__amt');
      if (amt) amt.textContent = fmt(Math.max(threshold - total, 0), el.dataset.currency);
    }
    if (!threshold) return;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    var done = total >= threshold;
    if (done) pct = 100;
    el.classList.toggle('is-done', done);
    var bar = el.querySelector('[role="progressbar"]');
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(pct)));
    var prev = getPrev();
    // start from where the bar was before this re-render, then glide to the new value
    el.classList.add('no-anim');
    el.style.setProperty('--p', String(prev === null ? 0 : prev));
    void el.offsetWidth;
    el.classList.remove('no-anim');
    requestAnimationFrame(function () {
      el.style.setProperty('--p', String(pct));
      el.classList.add('is-ready');
      if (done && (prev === null || prev < 100)) el.classList.add('is-celebrate');
    });
    setPrev(pct);
  }
  function scan() { document.querySelectorAll('.mms:not([data-ready])').forEach(setup); }
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; scan(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
